import { useEffect, useRef, useState } from 'react'
import { Globe, ShieldAlert } from 'lucide-react'

/* Banner die bovenaan verschijnt zodra de server publiek bereikbaar is.

   Twee triggers, samen met OR:
   1. Explicite toggle in service_config (admin zet aan bij Funnel-start)
   2. Automatische val: hostname eindigt op ts.net of trycloudflare.com

   Zo mis je hem niet als je vergeet te togglen, en verdwijnt hij zodra je
   weer via lanserver.local werkt. */

export default function PubliekeModusBanner() {
  const [zichtbaar, setZichtbaar] = useState(false)
  const [bron, setBron] = useState(null)
  const ref = useRef(null)

  useEffect(() => {
    // Snelste detectie: kijk naar de URL.
    const host = typeof window !== 'undefined' ? window.location.hostname : ''
    const viaTunnel = /\.ts\.net$/.test(host) || /trycloudflare\.com$/.test(host)
    if (viaTunnel) { setZichtbaar(true); setBron('tunnel'); return }

    // Anders vragen we het aan de server — die weet of admin de toggle heeft
    // aangezet ook al zit je nu op lanserver.local.
    fetch('/api/settings/public-mode')
      .then(r => r.json())
      .then(d => {
        if (d?.public_mode) { setZichtbaar(true); setBron('toggle') }
      })
      .catch(() => {})
  }, [])

  /* Meet de banner-hoogte en publiceer 'm als CSS-var op :root zodat de
     sidebar en content-area (Layout.jsx) hun eigen top-offset kunnen
     berekenen. Zonder deze var overlapt de banner het BuB-logo. */
  useEffect(() => {
    const root = document.documentElement
    if (!zichtbaar) { root.style.setProperty('--public-banner-h', '0px'); return }
    const update = () => {
      const h = ref.current?.offsetHeight || 0
      root.style.setProperty('--public-banner-h', `${h}px`)
    }
    update()
    const ro = new ResizeObserver(update)
    if (ref.current) ro.observe(ref.current)
    window.addEventListener('resize', update)
    return () => { ro.disconnect(); window.removeEventListener('resize', update); root.style.setProperty('--public-banner-h', '0px') }
  }, [zichtbaar])

  if (!zichtbaar) return null

  return (
    <div
      ref={ref}
      role="alert"
      className="fixed top-0 left-0 right-0 z-[60] border-b border-peach/40 text-peach"
      style={{
        background: 'color-mix(in srgb, rgb(var(--peach-rgb)) 15%, var(--background))',
        backdropFilter: 'blur(6px)',
      }}
    >
      <div className="flex items-center justify-center gap-2 px-4 py-1.5 text-sm">
        <ShieldAlert className="h-4 w-4 shrink-0" />
        <span className="font-semibold">Publieke modus actief</span>
        <span className="text-peach/75 hidden sm:inline">·</span>
        <span className="text-peach/75 hidden sm:inline">
          De server is bereikbaar via het internet
          {bron === 'tunnel' ? ' (herkend aan het adres)' : ''}. Wees voorzichtig met wat je opent.
        </span>
        <Globe className="h-3.5 w-3.5 opacity-60 ml-auto shrink-0" />
      </div>
    </div>
  )
}
